import { NgModule } from '@angular/core';
import { NgChartsModule } from 'ng2-charts';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './core/interceptor/auth.interceptor';
import { NgSelectModule } from '@ng-select/ng-select';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { HomeComponent } from './components/home/home.component';
import { LoginComponent } from './components/login/login.component';
import { SignupBasicComponent } from './components/signup-basic/signup-basic.component';
import { SignupPersonalComponent } from './components/signup-personal/signup-personal.component';
import { SignupProfessionalComponent } from './components/signup-professional/signup-professional.component';
import { SignupReligionComponent } from './components/signup-religion/signup-religion.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { ProfileListComponent } from './components/profile-list/profile-list.component';
import { ProfileDetailsComponent } from './components/profile-details/profile-details.component';
import { PartnerPreferencesComponent } from './components/partner-preferences/partner-preferences.component';
import { ChatComponent } from './components/chat/chat.component';
import { PlansComponent } from './components/plans/plans.component';

import { FavoritesComponent } from './components/favorites/favorites.component';
import { InterestsComponent } from './components/interests/interests.component';
import { MyProfileComponent } from './components/my-profile/my-profile.component';
import { MyHoroscopeComponent } from './components/my-horoscope/my-horoscope.component';
import { DivorcedComponent } from './components/divorced/divorced.component';
import { WidowedComponent } from './components/widowed/widowed.component';
import { MerchantRegisterComponent } from './merchant/merchant-register/merchant-register.component';
import { MerchantLoginComponent } from './merchant/merchant-login/merchant-login.component';
import { MerchantDashboardComponent } from './merchant/merchant-dashboard/merchant-dashboard.component';
import { MerchantProfileComponent } from './merchant/merchant-profile/merchant-profile.component';
import { MerchantServicesComponent } from './merchant/merchant-services/merchant-services.component';
import { MerchantServiceEditComponent } from './merchant/merchant-service-edit/merchant-service-edit.component';
import { MerchantLayoutComponent } from './merchant/merchant-layout/merchant-layout.component';
import { RouterModule } from '@angular/router';
import { MerchantCalendarComponent } from './merchant/merchant-calendar/merchant-calendar.component';
import { MerchantPortfolioComponent } from './merchant/merchant-portfolio/merchant-portfolio.component';
import { AdminLoginComponent } from './components/admin/admin-login/admin-login.component';
import { AdminShellComponent } from './components/admin/admin-shell/admin-shell.component';
import { AdminDashboardComponent } from './components/admin/admin-dashboard/admin-dashboard.component';
import { PlanManagerComponent } from './components/admin/plan-manager/plan-manager.component';
import { UserManagerComponent } from './components/admin/user-manager/user-manager.component';
import { BrokerManagerComponent } from './components/admin/broker-manager/broker-manager.component';
import { VerificationManagerComponent } from './components/admin/verification-manager/verification-manager.component';
import { ReportManagerComponent } from './components/admin/report-manager/report-manager.component';
import { SupportManagerComponent } from './components/admin/support-manager/support-manager.component';
import { SupportComponent } from './components/support/support.component';
import { MyTicketsComponent } from './components/my-tickets/my-tickets.component';
import { BrokerLoginComponent } from './components/broker/broker-login/broker-login.component';
import { BrokerDashboardComponent } from './components/broker/broker-dashboard/broker-dashboard.component';
import { ClaimProfileComponent } from './components/claim-profile/claim-profile.component';
import { RmLoginComponent } from './components/rm/rm-login/rm-login.component';
import { RmDashboardComponent } from './components/rm/rm-dashboard/rm-dashboard.component';
import { RmClientWorkspaceComponent } from './components/rm/rm-client-workspace/rm-client-workspace.component';
import { RmSearchComponent } from './components/rm/rm-search/rm-search.component';
import { AdminRmManagementComponent } from './components/admin/admin-rm-management/admin-rm-management.component';
import { RmConciergeChatComponent } from './components/matches/rm-concierge-chat/rm-concierge-chat.component';
import { ExpressConciergeRoomComponent } from './components/matches/express-concierge-room/express-concierge-room.component';
import { MerchantMessagesComponent } from './merchant/merchant-messages/merchant-messages.component';
import { ServiceCategoryComponent } from './wedding-services/service-category/service-category.component';
import { ServiceListComponent } from './wedding-services/service-list/service-list.component';
import { ServiceDetailsComponent } from './wedding-services/service-details/service-details.component';
import { MerchantDetailsComponent } from './wedding-services/merchant-details/merchant-details.component';
import { MerchantAboutUsComponent } from './merchant/merchant-about-us/merchant-about-us.component';
import { MerchantBookingComponent } from './merchant/merchant-booking/merchant-booking.component';
import { BookingFormComponent } from './wedding-services/booking-form/booking-form.component';
import { BookingCalendarComponent } from './wedding-services/booking-calendar/booking-calendar.component';
import { WeddingLayoutComponent } from './wedding-services/wedding-layout/wedding-layout.component';
import { BookingDetailsComponent } from './wedding-services/booking-details/booking-details.component';
import { PaymentDetailsComponent } from './wedding-services/payment-details/payment-details.component';
import { MerchantPaymentPreferenceComponent } from './merchant/merchant-payment-preference/merchant-payment-preference.component';
import { MerchantPaymentComponent } from './merchant/merchant-payment/merchant-payment.component';
import { MerchantRevenueComponent } from './merchant/merchant-revenue/merchant-revenue.component';
import { PaymentCheckoutComponent } from './wedding-services/payment-checkout/payment-checkout.component';
import { MerchantEnquiryComponent } from './merchant/merchant-enquiry/merchant-enquiry.component';
import { ServiceEnquiryComponent } from './wedding-services/service-enquiry/service-enquiry.component';
import { ServiceEnquiryListComponent } from './wedding-services/service-enquiry-list/service-enquiry-list.component';
import { MerchantSubscriptionComponent } from './merchant/merchant-subscription/merchant-subscription.component';
import { MerchantAdvertisementComponent } from './merchant/merchant-advertisement/merchant-advertisement.component';
import { MerchantLeadsComponent } from './merchant/merchant-leads/merchant-leads.component';
import { PostRequirementComponent } from './wedding-services/post-requirement/post-requirement.component';
import { MerchantManagerComponent } from './components/admin/merchant-manager/merchant-manager.component';
import { ShortlistedMerchantsComponent } from './wedding-services/shortlisted-merchants/shortlisted-merchants.component';

@NgModule({
  declarations: [
    AppComponent, 
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    LoginComponent,
    SignupBasicComponent,
    SignupPersonalComponent,
    SignupProfessionalComponent,
    SignupReligionComponent,
    DashboardComponent,
    ProfileListComponent,
    ProfileDetailsComponent,
    PartnerPreferencesComponent,
    ChatComponent,
    PlansComponent,
    FavoritesComponent,
    InterestsComponent,
    MyProfileComponent,
    MyHoroscopeComponent,
    DivorcedComponent,
    WidowedComponent,
    MerchantRegisterComponent,
    MerchantLoginComponent,
    MerchantDashboardComponent,
    MerchantProfileComponent,
    MerchantServicesComponent,
    MerchantServiceEditComponent,
    MerchantLayoutComponent,
    MerchantCalendarComponent,
    MerchantPortfolioComponent,
    AdminLoginComponent,
    AdminShellComponent,
    AdminDashboardComponent,
    PlanManagerComponent,
    UserManagerComponent,
    BrokerManagerComponent,
    VerificationManagerComponent,
    ReportManagerComponent,
    SupportManagerComponent,
    SupportComponent,
    MyTicketsComponent,
    BrokerLoginComponent,
    BrokerDashboardComponent,
    ClaimProfileComponent,
    RmLoginComponent,
    RmDashboardComponent,
    RmClientWorkspaceComponent,
    RmSearchComponent,
    AdminRmManagementComponent,
    RmConciergeChatComponent,
    ExpressConciergeRoomComponent,
    MerchantMessagesComponent,
    ServiceCategoryComponent,
    ServiceListComponent,
    ServiceDetailsComponent,
    MerchantDetailsComponent,
    MerchantAboutUsComponent,
    MerchantBookingComponent,
    BookingFormComponent,
    BookingCalendarComponent,
    WeddingLayoutComponent,
    BookingDetailsComponent,
    PaymentDetailsComponent,
    MerchantPaymentPreferenceComponent,
    MerchantPaymentComponent,
    MerchantRevenueComponent,
    PaymentCheckoutComponent,
    MerchantEnquiryComponent,
    ServiceEnquiryComponent,
    ServiceEnquiryListComponent,
    MerchantSubscriptionComponent,
    MerchantAdvertisementComponent,
    MerchantLeadsComponent,
    PostRequirementComponent,
    MerchantManagerComponent,
    ShortlistedMerchantsComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    SharedModule,
    NgSelectModule,
    RouterModule,
    NgChartsModule
  ],
  providers: [
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
